import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { WireframeBackground } from '@/components/WireframeBackground';
import { ActivityGraph } from './changelog/ActivityGraph';
import { StatsBar } from './changelog/StatsBar';
import { FilterBar } from './changelog/FilterBar';
import { Timeline } from './changelog/Timeline';
import type { CategoryKey } from './changelog/types';

export function Changelog() {
  const [activeFilter, setActiveFilter] = useState<CategoryKey | null>(null);

  return (
    <div className="relative min-h-full bg-background px-4 py-12">
      <WireframeBackground />
      <div className="relative z-10 mx-auto max-w-3xl">

        {/* Header */}
        <div className="mb-10">
          <Link
            to="/"
            className="mb-6 inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Back to home
          </Link>
          <h1 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Changelog
          </h1>
          <p className="mt-2 text-muted-foreground">
            A history of features, improvements, and fixes shipped to Meshpit.
          </p>
        </div>

        {/* Stats */}
        <div className="mb-6">
          <StatsBar />
        </div>

        {/* Activity graph */}
        <div className="mb-8 overflow-x-auto rounded-lg border border-border bg-muted/20 px-5 py-4">
          <ActivityGraph />
        </div>

        {/* Filter */}
        <div className="mb-8">
          <FilterBar active={activeFilter} onChange={setActiveFilter} />
        </div>

        {/* Timeline */}
        <Timeline activeFilter={activeFilter} />

        {/* Footer */}
        <div className="mt-16 border-t border-border pt-8 text-center">
          <p className="text-sm text-muted-foreground">
            Meshpit is actively developed.{' '}
            <Link
              to="/"
              className="text-foreground underline-offset-4 hover:underline"
            >
              Back to home
            </Link>
          </p>
        </div>

      </div>
    </div>
  );
}
